import React from "react";
import { Card, Row } from "antd";

import Description from "./Description";

const ProQqNew2 = ({ proinfo, title }) => {
  const data = proinfo || {};
  return (
    <Card title="产品明细">
      <h3 className="order_pro_title">{title}</h3>
      <div style={{ paddingLeft: "50px" }}>
        <Row>
          <Description term="400号码">{data.c_400_account}</Description>
          <Description term="400最低消费(元/月)">
            {data.c_lowest_money}
          </Description>
          <Description term="400话费充值金额">
            {data.c_recharge_momey}
          </Description>
        </Row>
      </div>
    </Card>
  );
};

export default ProQqNew2;



// WEBPACK FOOTER //
// ./src/components/xianxing/order/Pro400.js